module.exports = __webpack_public_path__ + "static/media/accessory9.7511452f.webp";